<template lang="pug">
  div
    el-row(:gutter="10")
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/idMunicipiosGleba')
          app-label(label="Município da gleba:", :required="true")
          el-select.full-width(
            multiple
            v-model='gleba.idMunicipiosGleba',
            placeholder='Selecione',
            clearable,
            filterable,
            no-match-text="Município não encontrado",
            @clear="gleba.idMunicipiosGleba = null"
            :class="{'error-select' : errors.length}"
          )
            el-option(
              v-for='m in municipios',
              :key='m.id',
              :label='m.nome',
              :value='m.id'
            )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/nome')
          app-label(label="Nome da gleba:")
          el-input.input(
            v-model="gleba.nome",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/areaTotal')
          app-label(label="Área total(ha):")
          app-double-input.input(
            v-model="gleba.areaTotal",
            name='Área total',
            :maxlength="20"
            :hasLimitValue="true"
            :precision="4",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(:rules="{ required: true, maxArea: gleba.areaTotal }", v-slot="{ errors }", name='/areaRemanescente')
          app-label(label="Áreas remanescentes (ha):")
          app-double-input.input(
            v-model="gleba.areaRemanescente",
            name='Áreas remanescentes',
            :maxlength="20"
            :hasLimitValue="true"
            :precision="4",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/nomeCartorio')
          app-label(label="Cartório:")
          el-input.input(
            v-model="gleba.nomeCartorio",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/idMunicipioCartorio')
          app-label(label="Município do cartório:")
          el-select.full-width(
            v-model='gleba.idMunicipioCartorio',
            placeholder='Selecione',
            clearable,
            filterable,
            no-match-text="Município não encontrado",
            @clear="gleba.idMunicipioCartorio = null"
            :class="{'error-select' : errors.length}"
          )
            el-option(
              v-for='m in municipios',
              :key='m.id',
              :label='m.nome',
              :value='m.id'
            )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
    el-row(:gutter="10" style="margin: 20px 0;")
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/matricula')
          app-label(label="Matrícula:")
          el-input.input(
            type="number"
            v-model="gleba.matricula",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/dataMatricula')
          app-label(label="Data matrícula:")
          el-date-picker.full-width(
            type="date",
            name='Data matrícula'
            v-model="gleba.dataMatricula",
            placeholder="Selecione",
            format="dd/MM/yyyy",
            value-format="yyyy-MM-dd",
            :picker-options="pickerOptions",
            :class="{'error-select' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/livro')
          app-label(label="Livro:")
          el-input.input(
            v-model="gleba.livro",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        validation-provider(rules="required", v-slot="{ errors }", name='/folha')
          app-label(label="Folha:")
          el-input.input(
            v-model="gleba.folha",
            :class="{'erro' : errors.length}"
          )
          span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-col(:lg="4", :md="12")
        app-label(label="Latitude:" :required="false")
        el-input.input(
          v-model="gleba.latitude"
          v-mask="[`##°##'##,###\"A`]"
        )
      el-col(:lg="4", :md="12")
        app-label(label="Longitude:" :required="false")
        el-input.input(
          v-model="gleba.longitude"
          v-mask="[`##°##'##,###\"A`]"
        )
    el-row(:gutter="10" style="margin: 50px 0;")
      validation-provider(rules="", v-slot="{ errors }", name="Georreferenciamento/Geometria")
        mapa-analise-geomensor(
          v-model="localizacoes",
          :localizacoes="localizacoes"
          name="Geometria",
          idMapa="mapaAnaliseGeomensor"
          :errors="errors"
          @dataEmitted="receiveDataFromChild"
          @areaEmitted="areaEmitted"
        )
</template>
<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import AppDoubleInput from '@/components/AppDoubleInput'
import { extend } from 'vee-validate'

extend('maxArea', {
  params: ['maxArea'],
  validate (value, { maxArea }) {
    return Number(value) <= Number(maxArea)
  },
  message: 'A área remanescente não pode ser maior que a área total.'
})

export default {
  components: {
    AppLabel,
    MapaAnaliseGeomensor,
    AppDoubleInput
  },

  mixins: [
  ],

  props: {
    gleba: {
      required: true
    },
    localizacoes: {
      required: true
    }
  },

  data () {
    return {
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  computed: {
  },

  async created () {
    this.municipios = await this.findMunicipiosByEstadoAtual()
    let nomes = []
    this.gleba.idMunicipiosGleba.forEach(id => {
      nomes.push((this.municipios.find(municipio => municipio.id === id)).nome)
    })

    return nomes.join(', ')
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      criarGleba: 'gleba/criarGleba'
    }),
    voltar () {
      this.$router.push({
        name: 'bancoDados/gleba',
        params: {}
      })
    },
    receiveDataFromChild (data) {
      this.gleba.idMunicipiosGleba = []
      data.forEach(item => {
        this.gleba.idMunicipiosGleba.push(item.id)
      })
    },
    areaEmitted (area) {
      this.gleba.areaTotal = area
      this.gleba.areaRemanescente = area
    }
  }
}

</script>
<style>
.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn {
    padding: 8px;
  }
}
.full-width {
  width: 100% !important;
}
.card-container {
  margin: 0px;
  margin-top: 30px;
  border-radius: 10px;
}
.instructions {
  padding-bottom: 20px;
  font-weight: bold;
  color: #606266 !important;
}
.btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.btn {
  padding : 0px !important;
  border: 0px;
}
.text-btn {
  margin: 3px !important;
}
.btn-cadastro-container {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}
.btn-cadastro {
  width: 200px;
}
.error-select {
  border: 1px solid #b22222;
  border-radius: 4px;
  border-color: #b22222;
  -webkit-box-shadow: inset 0 1px 2px #ff867c,0 0 9px #b22222;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/components/FormGleba.vue